import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import messages from './Navigation.messages';
import { NavLink } from './NavLink';
import { FLEXI_24_URL } from '../flexi24/dashboard.saga';
import { TERM_LOAN_URL } from '../termLoan/Dashboard.sagas';
import { RBL_URL } from '../revenueBasedLoan/dashboard/Dashboard.sagas';
import { RootState } from '../../iwProvider/configureStore';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { MY_OFFERS_URL } from '../myOffers/MyOffers.sagas';

const mapStateToProps = (state: RootState) => ({
    ...state.navigation
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const ProductDashboardLinks = ({
    showCBILS,
    showSecondCBILS,
    showRLS,
    showFlexi24,
    showFlexiLoan,
    showRBL,
    showTermLoan,
    className,
    activeClassName,
    showIwocaPay,
    showMyOffers
}: { className?: string; activeClassName?: string } & PropsFromRedux) => {
    return (
        <>
            {showMyOffers && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to={MY_OFFERS_URL}
                    disableRedirect={true}
                    data-testid="my-offers-navigation-link"
                >
                    <FormattedMessage {...messages.myOffers} />
                </NavLink>
            )}
            {showRLS && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to="/recovery-loan-scheme/"
                    data-testid="rls-navigation-link"
                >
                    RLS
                </NavLink>
            )}
            {showIwocaPay && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to="/iwocapay/"
                    data-testid="iwocaPay-navigation-link"
                >
                    iwocaPay
                </NavLink>
            )}
            {showRBL && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to={RBL_URL}
                    data-testid="rbl-navigation-link"
                >
                    {getCountry() === 'DE' ? 'eBay Flexi Kapital' : 'RBL'}
                </NavLink>
            )}
            {showCBILS && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to="/CBILS/"
                    data-testid="cbils-navigation-link"
                >
                    {showSecondCBILS ? (
                        <FormattedMessage {...messages.firstCBILS} />
                    ) : (
                        <FormattedMessage {...messages.CBILSDashboard} />
                    )}
                </NavLink>
            )}
            {showSecondCBILS && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to="/CBILS2/"
                    data-testid="second-cbils-navigation-link"
                >
                    <FormattedMessage {...messages.secondCBILS} />
                </NavLink>
            )}
            {showTermLoan && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to={TERM_LOAN_URL}
                    data-testid="term-loan-navigation-link"
                >
                    Business Loan
                </NavLink>
            )}
            {showFlexiLoan && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to="/"
                    disableRedirect={true}
                    data-testid="flexi12-navigation-link"
                >
                    <FormattedMessage {...messages.flexi12Dashboard} />
                </NavLink>
            )}

            {showFlexi24 && (
                <NavLink
                    className={className}
                    activeClassName={activeClassName}
                    to={FLEXI_24_URL}
                    disableRedirect={true}
                    data-testid="flexi24-navigation-link"
                >
                    <FormattedMessage {...messages.flexi24Dashboard} />
                </NavLink>
            )}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ProductDashboardLinks);
